import type { DateKey } from './types';

// YYYY-MM-DD in the device's local time zone. See plan/02 §Date keys for why
// local time and not UTC.
export function dateKey(d: Date = new Date()): DateKey {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
